import { MdClose } from "react-icons/md";
import styles from "./MenuModal.module.css";
import { forwardRef } from "react";
import { useNavigate } from "react-router-dom";

const MenuModal = forwardRef(function MenuModal({ props }, ref) {
  const handleClose = () => {
    const modalElement = ref.current;

    modalElement.classList.add(styles.closing);

    setTimeout(() => {
      modalElement.classList.remove(styles.closing);
      modalElement.close();
    }, 300);
  };

  const navigate = useNavigate();

  const handleNavigation = (path) => {
    ref.current.close();
    navigate(path);
  };

  return (
    <dialog className={styles.menuModalDialog} ref={ref}>
      <div className={styles.closeButton}>
        <button className={styles.close} onClick={handleClose}>
          <MdClose />
        </button>
      </div>
      <ul className={styles.menuModalList}>
        <li
          onClick={() => handleNavigation("/terms-of-service")}
          className={styles.menuItem}
        >
          Terms of Services
        </li>
        <li
          onClick={() => handleNavigation("/privacy-policy")}
          className={styles.menuItem}
        >
          Privacy Policy
        </li>
      </ul>
    </dialog>
  );
});

export default MenuModal;
